<template>
  <transition name="modal">
    <v-row justify="center">
      <div class="modal-container" v-bind:style="{ maxWidth: width + 'px' }">
        <v-dialog v-model="show" content-class="vuetify-modal">
          <v-card>
            <div class="modal-header">
              <slot name="header"></slot>
            </div>

            <div class="modal-body text-left">
              <slot name="body"></slot>
            </div>

            <div class="modal-footer">
              <slot name="footer"></slot>
            </div>
          </v-card>
        </v-dialog>
      </div>
    </v-row>
  </transition>
</template>

<script>
export default {
  name: 'VuetifyModal',
  methods: {
    closeModal: function() {
      this.$emit('close')
    }
  },
  props: {
    value: Boolean,
    width: {
      type: String,
      default: '400'
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
